import { WEB_STORAGE } from '../../constants'

export const onRefreshPage = () => {
  const newBuildVersion = sessionStorage.getItem(
    WEB_STORAGE.SAVED_BUILD_VERSION
  )
  if (newBuildVersion) {
    localStorage.setItem(WEB_STORAGE.REVIEWED_BUILD_VERSION, newBuildVersion)
    sessionStorage.removeItem(WEB_STORAGE.SAVED_BUILD_VERSION)
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.location.reload(true)
}

export const showVersionNotification = (
  buildVersion: string,
  showNotificationCallback: () => void
) => {
  const newBuildVersion = buildVersion !== 'None' ? buildVersion : ''
  const savedSessionBuildVersion = sessionStorage.getItem(
    WEB_STORAGE.SAVED_BUILD_VERSION
  )
  const reviewedBuildVersion = localStorage.getItem(
    WEB_STORAGE.REVIEWED_BUILD_VERSION
  )
  if (newBuildVersion) {
    if (!reviewedBuildVersion) {
      localStorage.setItem(WEB_STORAGE.REVIEWED_BUILD_VERSION, newBuildVersion)
      return
    }
    // if new session and user hasn't refreshed the page
    if (!savedSessionBuildVersion && reviewedBuildVersion !== newBuildVersion) {
      sessionStorage.setItem(WEB_STORAGE.SAVED_BUILD_VERSION, newBuildVersion)
      showNotificationCallback()
      return
    }
    // if new version available and user didn't get notification yet - show notification
    // when savedSessionBuildVersion equals newBuildVersion - it means that we've already sent notification
    if (
      savedSessionBuildVersion &&
      newBuildVersion !== savedSessionBuildVersion
    ) {
      sessionStorage.setItem(WEB_STORAGE.SAVED_BUILD_VERSION, newBuildVersion)
      showNotificationCallback()
    }
  }
}
